import { Button } from "@web/components/ui/button"
import { Card, CardContent } from "@web/components/ui/card"
import { useLanguage } from "@web/lib/contexts/language-context"
import { Info } from "lucide-react"

export const QueryNotFound = ({ navigate }) => {
	const { t } = useLanguage()

	return (
		<div className="flex min-h-screen flex-col bg-gray-50">
			<main className="flex flex-1 flex-col items-center p-4 md:p-8">
				<Card className="w-full max-w-md">
					<CardContent className="flex flex-col items-center justify-center py-10 text-center">
						<div className="rounded-full bg-gray-100 p-3">
							<Info className="h-6 w-6 text-gray-400" />
						</div>
						<h3 className="mt-4 font-medium text-lg">{t.queryPage.notFound.title}</h3>
						<p className="mt-2 text-gray-500 text-sm">{t.queryPage.notFound.description}</p>
						<Button className="mt-6" onClick={() => navigate(-1)}>
							{t.queryPage.notFound.button}
						</Button>
					</CardContent>
				</Card>
			</main>
		</div>
	)
}
